import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import garageConversionADUImage from '@/assets/garage-conversion-adu.jpg';

const CanITurnMyGarageIntoADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/garage-conversion-adu-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={garageConversionADUImage} 
              alt="Garage conversion to ADU before and after" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can I Turn My Garage into an ADU in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Learn about garage-to-ADU conversions in California, including requirements, costs, and the step-by-step conversion process.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California Garage Conversion Laws
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California law permits garage-to-ADU conversions under specific conditions. The garage must meet minimum size requirements (typically 220+ sq ft), have adequate ceiling height (minimum 7 feet), and comply with all ADU regulations. Parking replacement may be required depending on local ordinances and property characteristics.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Conversion Requirements and Building Codes
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Garage conversions require full kitchen and bathroom installations, proper insulation, flooring upgrades, and electrical system modifications. Windows must provide adequate natural light and ventilation, while egress windows ensure safety compliance. Professional structural assessment determines if foundation and framing modifications are necessary.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Cost and Timeline Considerations
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Garage ADU conversions typically cost $80,000-$200,000 depending on size, finishes, and infrastructure requirements. Projects usually take 4-8 months from permit approval to completion. Cost-saving factors include existing electrical access, adequate ceiling height, and minimal structural modifications needed.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Do I need to replace parking when converting my garage?</p>
                  <p>A: Requirements vary by city - some require replacement parking, others don't for ADU conversions.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: What's the minimum garage size for ADU conversion?</p>
                  <p>A: Generally 220+ square feet with 7-foot minimum ceiling height for habitable space.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanITurnMyGarageIntoADUCalifornia;